module.exports = __webpack_public_path__ + "static/media/retweet.f9e74b31.svg";